// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var App$PdgLookup = require("./App.bs.js");
var Client = require("react-dom/client");
var JsxRuntime = require("react/jsx-runtime");

((require('./styles.css')));

var domElement = document.querySelector("#app");

if (!(domElement == null)) {
  Client.createRoot(domElement).render(JsxRuntime.jsx(App$PdgLookup.make, {}));
}

/*  Not a pure module */
